import React, { useState } from 'react';
import { Stack, Box, Typography, Pagination } from "@mui/material";
import { useApiCall } from '~/single-page/hooks/useApiCall';
import SponsorsClient from "../api/SponsorsClient";
import SponsorCard from "~/components/Sponsors/Card";
import SearchField from '~/components/SearchField';
import { Grid, Skeleton } from "@mui/material";
import NoItemsMessage from "~/components/NoItemsMessage";
import { useNormalizedSearch } from '~/single-page/hooks/useNormalizedSearch';

export default function SponsorsPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [normalizedSearchTerm, setNormalizedSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const itemsPerPage = 12;

  const {
    data: sponsors = [],
    pending,
    success,
  } = useApiCall({
    apiCall: SponsorsClient.sponsors,
    init: true,
  });

  const filteredSponsors = useNormalizedSearch(sponsors || [], normalizedSearchTerm, [
    'name',
    'description'
  ]);

  const totalPages = Math.ceil(filteredSponsors.length / itemsPerPage);
  const currentSponsors = filteredSponsors.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Stack spacing={4} sx={{ maxWidth: '100%' }}>
      <Box>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', mb: 2, textAlign: 'center' }}>
          Nossos Patrocinadores
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 4, textAlign: 'center', color: 'text.secondary' }}>
          Conheça as empresas e organizações que apoiam nossos projetos e tornam
          possível o impacto social que geramos nas comunidades.
        </Typography>
      </Box>

      <SearchField 
        value={searchTerm}
        onChange={(e) => { 
          setSearchTerm(e.target.value);
          setNormalizedSearchTerm(e.target.normalizedValue);
          setPage(1);
        }}
        label="Pesquisar Patrocinadores..."
        placeholder="Digite o nome do patrocinador ou descrição"
      />

      <Box>
        {pending ? (
          <Grid container spacing={3}>
            {Array.from(new Array(12)).map((_, index) => (
              <Grid item xs={6} sm={4} md={3} key={index}>
                <Skeleton 
                  variant="rectangular" 
                  height={150} 
                  sx={{ borderRadius: 2 }}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <>
            {(!success || !sponsors.length) ? (
              <NoItemsMessage itemName="patrocinador" gender="masculino" />
            ) : (
              <>
                <Grid container spacing={3}>
                  {currentSponsors.map((sponsor) => (
                    <Grid 
                      item
                      xs={6}
                      sm={4}
                      md={3}
                      key={sponsor.id}
                    >
                      <SponsorCard sponsor={sponsor} />
                    </Grid>
                  ))}
                </Grid>

                {filteredSponsors.length === 0 && searchTerm && (
                  <Box sx={{ 
                    width: '100%', 
                    textAlign: 'center', 
                    py: 4 
                  }}>
                    <Typography color="text.secondary">
                      Nenhum patrocinador encontrado com o termo "{searchTerm}"
                    </Typography>
                  </Box>
                )}

                {filteredSponsors.length > itemsPerPage && (
                  <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center',
                    mt: 4
                  }}>
                    <Pagination 
                      count={totalPages}
                      page={page}
                      onChange={handlePageChange}
                      color="primary"
                      size="large"
                    />
                  </Box>
                )}
              </>
            )}
          </>
        )}
      </Box>
    </Stack>
  );
} 